import * as core from '../../ultron-turing-manager/src/services/appfactoryApi'

export type {
  AppSuiteIAMClient,
  AppSuiteIAMDeveloper,
  AppSuiteIAMQuota,
  AppSuiteIAMUploadedUser,
  AppSuiteAvailableProjectId,
  AppSuiteProject,
  AppSuiteLibraryAsset,
  AppSuiteLibraryTreeNode,
  AppSuiteUserAccess,
  AppSuiteUserInvitation,
  DeployRecord,
} from '../../ultron-turing-manager/src/services/appfactoryApi'

export { APPSUITE_ACTIVE_CLIENT_CHANGED_EVENT } from '../../ultron-turing-manager/src/services/appfactoryApi'

export const listAppSuiteUserClients = () => core.listAppSuiteUserClients()
export const listAppSuiteUsersByClient = (clientId: string) => core.listAppSuiteUsersByClient(clientId)
export const createAppSuiteUserInvitation = (
  clientId: string,
  payload: { email: string; name?: string; role?: string; inviterName?: string }
) => core.createAppSuiteUserInvitation(clientId, payload)
export const getAppSuiteUserQuota = (clientId: string) => core.getAppSuiteUserQuota(clientId)
export const setAppSuiteUserQuota = (
  clientId: string,
  payload: { maxUsers: number; pendingInvites?: number }
) => core.setAppSuiteUserQuota(clientId, payload)
export const listAppSuiteUploadedUsers = (clientId: string) => core.listAppSuiteUploadedUsers(clientId)
export const uploadAppSuiteUsers = (
  clientId: string,
  users: Array<{ email: string; name?: string; status?: string; source?: string }>
) => core.uploadAppSuiteUsers(clientId, users)
export const getAppSuiteActiveClientId = () => core.getAppSuiteActiveClientId()
export const setAppSuiteActiveClientId = (clientId: string) => core.setAppSuiteActiveClientId(clientId)
export const getAppSuiteCurrentClientId = () => core.getAppSuiteActiveClientId()
export const resolveAppSuiteRuntimeClientId = (_input?: { hostname?: string; search?: string }) =>
  core.getAppSuiteActiveClientId() || undefined
export const syncAppSuiteClientIdFromRuntime = () => {
  const id = core.getAppSuiteActiveClientId()
  if (id) core.setAppSuiteActiveClientId(id)
}

export const listAppSuitePublishedTemplates = () => core.listAppSuitePublishedTemplates()
export const listAppSuitePublishedComponentStyles = () => core.listAppSuitePublishedComponentStyles()
export const listAppSuitePublishedDeviceTypeModals = () => core.listAppSuitePublishedDeviceTypeModals()
export const listAppSuiteAvailableProjectIds = () => core.listAppSuiteAvailableProjectIds()
export const getAppSuiteProject = (projectId: string) => core.getAppSuiteProject(projectId)
export const listAppSuiteProjects = () => core.listAppSuiteProjects()
export const createAppSuiteProject = (payload: { name: string; platform?: string; clientId: string }) =>
  core.createAppSuiteProject(payload)
export const forkAppSuiteProjectFromTemplate = (payload: {
  projectId: string
  templateId: string
  templateVersion?: string
  templateSnapshot?: Record<string, unknown>
}) =>
  core.forkAppSuiteProjectFromTemplate(payload)
export const deleteAppSuiteProject = (projectId: string) => core.deleteAppSuiteProject(projectId)
export const updateAppSuiteProjectStyleOverrides = (projectId: string, patch: Record<string, unknown>) =>
  core.updateAppSuiteProjectStyleOverrides(projectId, patch)
export const updateAppSuiteProjectConfig = (projectId: string, patch: Record<string, unknown>) =>
  core.updateAppSuiteProjectConfig(projectId, patch)
export type { AppSuiteDeviceType } from '../../ultron-turing-manager/src/services/appfactoryApi'
export const listAppSuiteClientDeviceTypes = (clientId: string) => core.listAppSuiteClientDeviceTypes(clientId)
export const deployAppSuiteProject = (payload: {
  projectId: string
  target?: 'production' | 'preview'
  provider?: 'firebase' | 'vercel'
  releaseNotes?: string
  productId?: string
}) =>
  core.deployAppSuiteProject(payload)

export const addAppSuitePublishedAssetToLibrary = (payload: {
  clientId: string
  assetType: 'app_template' | 'device_type_modal' | 'component_style'
  assetId: string
}) => core.addAppSuitePublishedAssetToLibrary(payload)

export const listAppSuiteLibraryAssets = (params: {
  clientId: string
  assetType?: 'app_template' | 'device_type_modal' | 'component_style'
  bundleId?: string
}) => core.listAppSuiteLibraryAssets(params)

export const listAppSuiteLibraryTree = (params: {
  clientId: string
}) => core.listAppSuiteLibraryTree(params)

export const removeAppSuiteLibraryAsset = (params: {
  clientId: string
  assetId: string
}) => core.removeAppSuiteLibraryAsset(params)

export const listDeployHistory = () => core.listDeployHistory()
export const listAnnouncements = () => core.listAnnouncements()

export type { AppSuiteClientApp } from '../../ultron-turing-manager/src/services/appfactoryApi'
export const listClientApps = (clientId: string) => core.listClientApps(clientId)
export const registerClientApp = (clientId: string, payload: Parameters<typeof core.registerClientApp>[1]) =>
  core.registerClientApp(clientId, payload)
export const deleteClientApp = (clientId: string, id: string) => core.deleteClientApp(clientId, id)
export const lookupClientApps = (clientId: string, payload: Parameters<typeof core.lookupClientApps>[1]) =>
  core.lookupClientApps(clientId, payload)
export const connectFirebaseApp = (clientId: string, payload: Parameters<typeof core.connectFirebaseApp>[1]) =>
  core.connectFirebaseApp(clientId, payload)
export const discoverAccessibleApps = (clientId: string, accessToken: string) =>
  core.discoverAccessibleApps(clientId, accessToken)
export const getUltronCloudFirebaseConfig = () => core.getUltronCloudFirebaseConfig()
export type { UltronCloudFirebaseConfig } from '../../ultron-turing-manager/src/services/appfactoryApi'

export const acceptAppSuiteUserInvitation = (token: string) => core.acceptAppSuiteUserInvitation(token)
export const getAppSuiteUserAccess = () => core.getAppSuiteUserAccess()

export type { AppSuiteBrandConfig, AppSuiteReleaseChannel, AppSuiteRelease, AppSuitePublishJob } from '../../ultron-turing-manager/src/services/appfactoryApi'
export const getClientBrandConfig = (clientId: string) => core.getClientBrandConfig(clientId)
export const setClientBrandConfig = (clientId: string, config: Parameters<typeof core.setClientBrandConfig>[1]) =>
  core.setClientBrandConfig(clientId, config)
export const getClientChannels = (clientId: string) => core.getClientChannels(clientId)
export const deployForClient = (clientId: string, payload: Parameters<typeof core.deployForClient>[1]) =>
  core.deployForClient(clientId, payload)
export const getClientReleases = (clientId: string, opts?: Parameters<typeof core.getClientReleases>[1]) =>
  core.getClientReleases(clientId, opts)
export const rollbackClientRelease = (clientId: string, releaseId: string, reason?: string) =>
  core.rollbackClientRelease(clientId, releaseId, reason)
export const getClientPublishJobs = (clientId: string) => core.getClientPublishJobs(clientId)
export const listAppSuiteUserInvitations = (clientId: string) => core.listAppSuiteUserInvitations(clientId)
export const removeAppSuiteUser = (clientId: string, userId: string) => core.removeAppSuiteUser(clientId, userId)
export const revokeAppSuiteInvitation = (clientId: string, invitationId: string) => core.revokeAppSuiteInvitation(clientId, invitationId)

export type { TemplatePreviewMode, AppFactoryTemplatePreviewLink } from '../../ultron-turing-manager/src/services/appfactoryApi'
export const generateTemplatePreviewLinkByMode = (
  templateId: string,
  options?: Parameters<typeof core.generateTemplatePreviewLinkByMode>[1]
) => core.generateTemplatePreviewLinkByMode(templateId, options)

export const createAppSuiteSharePreview = (projectId: string) => core.createAppSuiteSharePreview(projectId)

export const getCredentialFromUserProfile = () => core.getCredentialFromUserProfile()
export const setCredentialInUserProfile = (appId: string, apiKey: string) => core.setCredentialInUserProfile(appId, apiKey)
export const clearCredentialFromUserProfile = () => core.clearCredentialFromUserProfile()

export type { AppSuiteRuntimeConfig } from '../../ultron-turing-manager/src/services/appfactoryApi'
export const getRuntimeConfig = (appId: string) => core.getRuntimeConfig(appId)
